module.exports = __webpack_public_path__ + "img/CS-Hybrid-Profiles.e8c1b71a.jpg";